import { render, staticRenderFns } from "./BeeHeroPack.vue?vue&type=template&id=ef12b09c"
import script from "./BeeHeroPack.vue?vue&type=script&lang=js"
export * from "./BeeHeroPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports